/*
 * Pawbau reels: vertical customer clips (home section pawbau-customer-videos, product block pawbau-product-videos).
 * Each clip plays muted while it is on screen; a tap on the clip plays or pauses it, the round button turns the sound on.
 */
if (!customElements.get('pawbau-reels')) {
  customElements.define(
    'pawbau-reels',
    class extends HTMLElement {
      connectedCallback() {
        this.videos = [...this.querySelectorAll('video')];
        const still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        // each clip plays only while it is on screen, so the page stays light
        this.watcher = new IntersectionObserver(
          (entries) => {
            for (const { target, isIntersecting } of entries) {
              if (isIntersecting && !still) {
                target.play().catch(() => {});
              } else {
                target.pause();
              }
            }
          },
          { threshold: 0.6 }
        );
        this.videos.forEach((video) => this.watcher.observe(video));

        this.addEventListener('click', (event) => {
          const button = event.target.closest('.pawbau-reel__sound');
          const frame = event.target.closest('.pawbau-reel__frame');
          const video = frame?.querySelector('video');
          if (!video) return;
          if (!button) {
            // a tap on the clip itself: play or pause
            if (video.paused) video.play().catch(() => {});
            else video.pause();
            return;
          }
          const on = video.muted;
          // one voice at a time
          this.videos.forEach((other) => {
            other.muted = true;
            other.closest('.pawbau-reel__frame')?.querySelector('.pawbau-reel__sound')?.setAttribute('aria-pressed', 'false');
          });
          video.muted = !on;
          button.setAttribute('aria-pressed', String(on));
          if (on) video.play().catch(() => {});
        });
      }

      disconnectedCallback() {
        this.watcher?.disconnect();
      }
    }
  );
}
